import styled from "styled-components";
import {size} from "../../helpers/breakpoints";

export const Container = styled.div`
  width: 100%;
  height: 90px;
  border: 1px solid var(--border-color);
  padding: 1.5rem;
  margin-bottom: .75rem;
  border-radius: 6px;
  transition: .2s;
  cursor: pointer;
  background-color: ${props => props.active ? 'var(--accent-color)' : 'transparent'};
  
  &:hover {
    border-color: var(--accent-color);
  }
  
  @media only screen and (max-width: ${size.sm}) {
    overflow: hidden;
    padding: .5rem;
  }
`;

export const AvatarImage = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
`;

export const UserStatus = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  position: absolute;
  top: 0;
  right: 3px;
`;

export const NickName = styled.p`
  width: 250px;
  font-size: .95rem;
  color: ${props => props.active && '#fff'};
`;

export const ContentText = styled.p`
  width: 250px;
  font-size: .8rem;
  color: ${props => props.active ? '#fff' : '#adb5bd'};
`;

export const UnReadBadge = styled.div`
  min-width: 25px;
  min-height: 25px;
  height: 25px;
  width: 25px;
  margin-left: .7rem;
  border-radius: 50%;
  background-color: var(--accent-color);
  color: #FFF;
  font-size: .7rem;
`;
